// Revenue unit is billion (bn)
// Source based on : Statista

export const marketShareData = [
    0.449,
    0.259,
    0.211,
    0.081
]